import type { Resources } from './en';

const es: Resources = {
  nav: {
    home: 'Inicio de MixGenie',
    appNav: 'Navegación de la app',
    signIn: 'Iniciar sesión',
    signUp: 'Crear cuenta',
    install: 'Instalar',
    micAttached: 'Grabación adjunta como referencia',
  },
  common: {
    cancel: 'Cancelar',
    save: 'Guardar',
    close: 'Cerrar',
  },
  settings: {
    title: 'Ajustes',
    theme: 'Tema',
    themeAuto: 'Auto',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    language: 'Idioma',
    tutorial: 'Tutorial',
    tutorialCta: 'Hazme un tour',
    tutorialToastTitle: 'Tour guiado',
    tutorialToastBody: 'El tutorial llega en la próxima versión — mientras tanto, suelta una Referencia, elige un Preset y pulsa el botón ↑.',
    buildLabel: 'Build',
    iconsCredit: 'Iconos: Solar de 480 Design, con licencia CC BY 4.0',
    linkSupport: 'Soporte',
    linkPrivacy: 'Política de privacidad',
    linkTerms: 'Términos',
    linkRefund: 'Política de reembolsos',
  },
  languages: {
    en: 'Inglés',
    es: 'Español',
    pt: 'Portugués',
  },
  footer: {
    about: 'Quiénes somos',
    contact: 'Contacto',
    help: 'Centro de ayuda ↗',
    terms: 'Términos y condiciones',
    privacy: 'Privacidad y cookies',
  },
  composer: {
    emptyTitle: 'Crea una canción',
    emptySub: 'Empieza con una idea, una referencia o un preset.',
    typeIdea: 'Escribe una idea',
    uploadReference: 'Subir referencia',
    pickPreset: 'Elegir un preset',
    mySongs: 'Mis canciones',
    orType: 'o simplemente escribe abajo — también vale empezar sin nada.',
    composingTitle: 'Componiendo tu canción…',
    composingSub: 'Letra · voz · arreglos · portada. Suele tardar 2–4 min.',
    describePlaceholder: 'Describe tu canción — p. ej. "indie pop melancólico sobre un domingo lluvioso"',
    lyricsPlaceholder: 'Pega aquí tu letra (opcional). Déjalo en blanco y MixGenie la escribe.',
    reference: 'Referencia',
    presets: 'Presets',
    lyricsOff: '+ Letra',
    lyricsOn: 'Letra',
    instrumental: 'Instrumental',
    generating: 'Generando…',
    pricePerSong: '1 crédito por canción',
    signInFree: 'Iniciar sesión · 2 gratis',
    generateAria: 'Generar',
  },
  generator: {
    title: 'Crea tu canción',
    workingAria: 'Generando tu canción',
    cancel: 'Cancelar',
    refSearchPlaceholder: 'Busca una canción como referencia…',
    refSearchEmpty: 'Sin resultados. Prueba con otro título o artista.',
    refSearchExternal: 'De Genius / iTunes — se importa al elegir',
    imageTooLarge: 'Imagen demasiado grande (máx. 12 MB)',
    inspireDone: 'Brief de canción creado desde la imagen',
    inspireFail: 'No se pudo interpretar la imagen',
    inspireBusy: 'Leyendo la imagen…',
    inspireCtaShort: 'Crea una canción desde una foto',
    inspireReading: 'MixGenie ve',
    referenceAttached: 'Referencia adjunta',
    referenceLabel: 'Canción de referencia',
    referenceHintShort: 'Opcional — busca, elige o graba una pista como referencia.',
    referenceUsingLocal: 'Usando tu archivo como semilla de audio',
    pickDeviceFile: 'Elegir del dispositivo',
    recordMic: 'Grabar con el micro',
    micAttached: 'Grabación adjunta como referencia',
    untitled: 'Canción de MixGenie',
    generateAnother: 'Generar otra',
    working: 'Generando…',
    needBase: 'Añade un prompt o una referencia',
    needLyrics: 'Añade letra o marca Instrumental',
    needPromptOrReference: 'Añade un prompt o una canción de referencia para generar.',
    generate: 'Generar canción',
    lyricsDraftEmpty: 'No se pudo redactar la letra — prueba a añadir un prompt o un tema.',
    lyricsDraftFailed: 'No se pudo redactar',
    tooFast: 'Un momento — espera un par de segundos antes de volver a generar.',
    failed: 'Falló la generación. Vuelve a intentarlo.',
    newBrief: 'Nuevo',
    promptLabel: 'Prompt',
    addSoundPreset: 'Añadir estilo / instrumento',
    promptPlaceholder: 'p. ej. Synth-wave oscuro con bajo potente, aire cinematográfico, producción de los 2020',
    lyricsLabel: 'Letra',
    addLyricTheme: 'Añadir tema para la letra',
    lyricsLanguageLabel: 'Idioma',
    draftLyrics: 'Redactar letra',
    instrumental: 'Solo instrumental',
    instrumentalOn: 'Instrumental seleccionado — letra desactivada.',
    lyricsPlaceholder: 'Escribe o pega aquí tu letra. Pulsa ✨ Redactar letra para que MixGenie te proponga una.',
    jobFailed: 'Falló la generación',
    done: 'Listo',
    viewAll: 'Mis canciones',
    nowPlaying: '🎵 Sonando en el reproductor inferior — úsalo para pausar, buscar y controlar el volumen.',
    download: 'Descargar',
    withCoverShort: '+ Portada',
    paywallTitle: 'Te quedaste sin créditos',
    paywallBody: 'Compra un pack de créditos o suscríbete para seguir generando.',
    pw1: 'Generación de canciones ilimitada',
    pw2: 'Cola prioritaria',
    pw3: 'Descargas en HD',
    seePlans: 'Ver planes',
    queueFullTitle: 'Ya tienes canciones en la cola',
    queueFullBody: 'Los planes gratuitos permiten {{limit}} generaciones a la vez. Espera a que termine alguna — o mejora tu plan para correr más en paralelo.',
    queueFullBodyGeneric: 'Espera a que termine alguna — o mejora tu plan para correr más en paralelo.',
    qf1: 'Sáltate la cola del plan gratis',
    qf2: 'Varias generaciones en paralelo',
    qf3: 'Procesamiento prioritario',
    queueFullWait: 'Espero',
    queueFullUpgrade: 'Mejorar',
  },
  genOverlay: {
    push: {
      done: 'Te avisamos en cuanto esté lista ✓',
      prompt: '¿Quieres un aviso cuando termine?',
      yes: 'Sí',
      no: 'No, gracias',
    },
  },
  credits: {
    checkoutSuccess: 'Pago recibido — tus créditos se están actualizando.',
    checkoutCancelled: 'Pago cancelado.',
  },
  history: {
    title: 'Mis canciones',
    untitled: 'Sin título',
    loadError: 'No se pudieron cargar tus canciones.',
    empty: 'Aún no has creado ninguna canción.',
    emptyPlaylist: 'Esta playlist está vacía. Añade canciones desde Todas las canciones.',
    emptyCta: 'Crea tu primera canción',
    playlistCreated: 'Playlist creada — canción añadida',
    playlistCreateFail: 'No se pudo crear la playlist',
    favFail: 'No se pudo actualizar — vuelve a intentarlo',
    linkCopied: 'Enlace copiado',
    downloadFailed: 'Falló la descarga',
    lyricsCopied: 'Letra copiada',
    lyricsCopyFail: 'No se pudo copiar — selecciona el texto a mano',
    failedArt: 'Esta generación ha fallado',
    unavailable: 'No disponible',
    processing: 'Generando…',
    share: 'Compartir',
    rename: 'Renombrar',
    viewLyrics: 'Ver letra',
    generateSimilar: 'Generar similar',
    openStudio: 'Abrir en Studio',
    download: 'Descargar',
    playlists: 'Playlists',
    newPlaylistFromSong: 'Nueva playlist con esta canción',
    noPlaylists: 'Aún no hay más playlists.',
    confirmDelete: '¿Eliminar "{{title}}"? Se borra la canción y su audio para siempre.',
    deleted: 'Canción eliminada',
    delete: 'Eliminar canción',
    renameTitle: 'Renombrar canción',
    renameLabel: 'Título de la canción',
    lyricsFor: 'Letra',
    copyLyrics: 'Copiar',
    newSongWithLyrics: 'Nueva canción con esta letra',
    playlistNameLabel: 'Nombre de la playlist',
    playlistNamePlaceholder: 'p. ej. Vibes relax',
    playlistCreateAndAdd: 'Crear y añadir',
  },
  player: {
    coverDone: 'Portada generada — actualizando…',
    coverFail: 'Falló la generación de la portada — vuelve a intentarlo',
    coverTooLarge: 'Imagen demasiado grande (máx. 12 MB)',
    coverUploaded: 'Portada actualizada',
    coverUploadFail: 'Falló la subida — vuelve a intentarlo',
    coverPainting: 'Pintando la portada con pictools.ai…',
    coverCta: 'Generar portada con pictools.ai',
    coverCost: '1 crédito',
    coverUploading: 'Subiendo portada…',
    coverUploadCta: 'Subir desde el dispositivo / cámara',
    linkCopied: 'Enlace copiado',
    confirmDelete: '¿Eliminar "{{title}}"? Se borra la canción para siempre.',
    deleted: 'Canción eliminada',
    menuShare: 'Compartir',
    menuDownload: 'Descargar',
    menuRename: 'Renombrar',
    menuGenerateSimilar: 'Generar similar',
    menuMakeVideo: 'Crear vídeo',
    menuDelete: 'Eliminar',
    renameTitle: 'Renombrar canción',
    renameLabel: 'Título de la canción',
  },
  userMenu: {
    signedInAs: 'Sesión iniciada como',
    anonymous: 'Usuario',
    mySongs: 'Mis canciones',
    library: 'Biblioteca de música',
    credits: 'Créditos',
    themeLight: 'Tema claro',
    themeDark: 'Tema oscuro',
    help: 'Ayuda y soporte ↗',
    signOut: 'Cerrar sesión',
  },
  push: {
    label: 'Notificaciones',
    title: 'Avísame cuando una canción esté lista',
    blocked: 'Las notificaciones están bloqueadas en los ajustes del navegador para este sitio. Actívalas desde la barra de direcciones (icono del candado) → Permisos.',
    subscribed: 'Estás suscrito en este dispositivo. Desactiva para parar.',
    pitch: 'Recibe un aviso en cuanto termine tu canción — no hace falta tener la pestaña abierta.',
    toggle: 'Activar / desactivar notificaciones',
    openSettings: 'Abrir ajustes de notificaciones del navegador',
  },
  invite: {
    title: 'Invita a tus amigos, gana créditos',
    subtitle: 'Ambos recibís {{r}} créditos cuando se registren{{p}}.',
    subtitlePurchase: ' — y {{n}} más cuando compren su primer pack',
    subtitleReferrerOnly: 'Consigue {{n}} créditos cada vez que un amigo se registre con tu enlace.',
    shareTitle: 'Haz canciones con MixGenie',
    shareText: 'Únete a MixGenie — los dos recibimos {{n}} créditos gratis.',
    shareTextNoBonus: 'Únete a MixGenie — generador de canciones gratis.',
    copied: 'Enlace de invitación copiado',
    copyFailed: 'No se pudo copiar — mantén pulsado el enlace para compartirlo manualmente',
    codeCopied: 'Código copiado',
    copyCode: 'Copiar código',
    linkCopied: 'Enlace copiado ✓',
    share: 'Comparte tu enlace de invitación',
    statsInvites: '{{n}} se unieron',
    statsEarned: 'ganados',
  },
  video: {
    eyebrow: 'Crear vídeo',
    formatLabel: 'Formato',
    styleLabel: 'Fondo',
    styleRandom: 'Aleatorio',
    styleRandomHint: 'Un look distinto cada vez que renderizas — ideal para sacar variantes sin pensarlo.',
    watermark: 'Mostrar marca de agua de mixgenie.ai',
    karaoke: 'Letra karaoke (sincronización estimada)',
    karaokeHint: 'El timing por línea se estima a partir de la duración — suele estar a uno o dos tiempos del real.',
    karaokeSynced: 'Letra karaoke (palabra a palabra)',
    karaokeSyncedHint: 'Timing palabra a palabra desde el proveedor — da en cada sílaba.',
    karaokeNoLyrics: 'Esta canción no tiene letra registrada.',
    rendering: 'Renderizando en tiempo real — la canción sonará una vez de principio a fin.',
    ready: 'El vídeo está listo — pulsa Descargar para guardarlo.',
    cancel: 'Parar',
    render: 'Renderizar vídeo',
    renderAgain: 'Renderizar otra vez',
    download: 'Descargar',
    coverFailed: 'No se pudo cargar la portada — renderizando sin ella.',
  },
};

export default es;
